import { IDiscussionState } from './IDiscussionState';

export const initialState: IDiscussionState = {
  byId: {},
  wordCloud: undefined,
  publishDefaults: null,
};
